/**
 * Paper grain — the noise layer jitters a few times a second, like film.
 *
 * @module chrome/paper-grain
 */

import { REDUCED_MOTION } from '../config.js';
import { $ } from '../lib/dom.js';
import { gsap } from '../lib/gsap.js';

export function animatePaperGrain() {
    const grain = $('.paper-grain');

    if (!grain || REDUCED_MOTION) {
        return;
    }

    gsap.to(grain, {
        duration: 0.4,
        repeat: -1,
        repeatRefresh: true,
        ease: 'steps(1)',
        x: () => `${gsap.utils.random(-4, 4, 1)}%`,
        y: () => `${gsap.utils.random(-4, 4, 1)}%`,
    });
}
